import { ContactChannel } from "@/types/__generated__/union-types"

const isMissingPatientContactInformation = (contactChannel?: ContactChannel) => {
  if (!contactChannel) return true

  return contactChannel === "NO_CHANNEL"
}

export { isMissingPatientContactInformation }
